import { Trans } from '@lingui/react/macro';
import { Settings2, ShieldCheck } from 'lucide-react';
import { Outlet } from '@tanstack/react-router';
import { PageTabs } from '@/common/components/page-tabs/PageTabs';

export function SupplyPointSettingsPage() {
  return (
    <div className="space-y-6 pb-10">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">
          <Trans>Settings</Trans>
        </h1>
        <p className="text-muted-foreground mt-1 text-sm">
          <Trans>Manage supply point details and access.</Trans>
        </p>
      </div>

      <PageTabs>
        <PageTabs.List>
          <PageTabs.Tab to="/settings/details" icon={Settings2}>
            <Trans>Details</Trans>
          </PageTabs.Tab>
          <PageTabs.Tab to="/settings/access" icon={ShieldCheck}>
            <Trans>Access management</Trans>
          </PageTabs.Tab>
        </PageTabs.List>
        <Outlet />
      </PageTabs>
    </div>
  );
}
